import { Window } from "../Container/Window/Window";
import { SelectorHead } from "./SelectorHead";
import { SelectorItem } from "./SelectorItem";
import { List } from "../Container/List/List";
import { CFlexContainer } from "../Container/CFlexContainer";
import { App as EntityApp } from "../../Entity/App";
import { getDataRepository, toMap } from "../../../../HA";

export class DSelector extends Window {

    public getSelections(): any[] {
        const data = [];
        this.getItems().forEach((s: SelectorItem) => {
            if (s && s.isChecked()) {
                data.push(s.getValue());
            }
        });

        return data;
    }

    protected getItems() {
        return this.getList().getItems();
    }

    protected getList() {
        return this.get("list");
    }

    protected initialize(data: any) {
        super.initialize(data);
        this.appendChild(this.createHead());
        this.addClass("ds");
        if (this.has("sd")) {
            this.initFromSD();
        } else {
            this.initList();
        }
    }

    private initFromSD(): void {
        getDataRepository().fetchData(this.get("sd")).then((response: Map<any, any>) => {
            const data = toMap(response.get("app"));
            if (this.has("pfunc")) {
                data.set("pfunc", this.get("pfunc"));
            }
            const app = new EntityApp(data as Map<string, any>);
            this.appendChild(app.getTag());
        });
    }

    private initList() {
        const list = new List(new CFlexContainer());
        list.addClass("dl");

        const dataList = this.get("dlist");
        if (dataList) {
            dataList.forEach((data: Map<any, any>) => {
                list.addItem(this.createItem(data));
            });
        }
        this.addToData("list", list);
        this.appendChild(list);
    }

    private createHead(data?: any) {
        return new SelectorHead(data);
    }

    private createItem(data: any) {
        if (this.has("pfunc")) {
            data.set("pfunc", this.get("pfunc").itemClick);
        }
        return new SelectorItem(data);
    }
}
